import { LegalHeader } from "../components/landing/LegalHeader";
import { LandingFooter } from "../components/landing/LandingFooter";

export default function ImpressumPage() {
  return (
    <div className="min-h-screen font-['Inter',system-ui,sans-serif] bg-white">
      <LegalHeader />

      <main className="pt-36 md:pt-44 pb-24 md:pb-32" data-testid="impressum-content">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="max-w-3xl">

            <h1 className="font-bold text-gray-900 text-3xl md:text-4xl lg:text-5xl tracking-tight mb-12 md:mb-16">
              Impressum
            </h1>

            <div className="space-y-10 md:space-y-12">

              <section>
                <h2 className="font-semibold text-gray-900 text-lg md:text-xl mb-4">
                  Angaben gemäß § 5 TMG
                </h2>
                <div className="text-gray-500 text-[15px] leading-relaxed space-y-1">
                  <p className="font-medium text-gray-900">TGAone OHG</p>
                  <p>Dammersbacher Straße 7</p>
                  <p>36088 Hünfeld</p>
                  <p>Deutschland</p>
                </div>
                <div className="text-gray-500 text-[15px] leading-relaxed mt-6">
                  <p className="font-medium text-gray-900 mb-1">Vertreten durch die Gesellschafter:</p>
                  <p>Ronny Pforr</p>
                  <p>Florian Trautmann</p>
                </div>
              </section>

              <section>
                <h2 className="font-semibold text-gray-900 text-lg md:text-xl mb-4">
                  Kontakt
                </h2>
                <div className="text-gray-500 text-[15px] leading-relaxed space-y-1">
                  <p>Telefon: <a href="tel:+491784061676" className="text-gray-900 hover:underline">+49 178 4061676</a></p>
                  <p>Telefon: <a href="tel:+491723023898" className="text-gray-900 hover:underline">+49 172 3023898</a></p>
                  <p>E-Mail: <a href="mailto:info@tgaone.de" className="text-gray-900 hover:underline">info@tgaone.de</a></p>
                </div>
              </section>

              <section>
                <h2 className="font-semibold text-gray-900 text-lg md:text-xl mb-4">
                  Umsatzsteuer
                </h2>
                <p className="text-gray-500 text-[15px] leading-relaxed">
                  Eine Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz liegt derzeit nicht vor.
                </p>
              </section>

              <section>
                <h2 className="font-semibold text-gray-900 text-lg md:text-xl mb-4">
                  Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV
                </h2>
                <div className="text-gray-500 text-[15px] leading-relaxed space-y-1">
                  <p className="font-medium text-gray-900">Ronny Pforr</p>
                  <p>Dammersbacher Straße 7</p>
                  <p>36088 Hünfeld</p>
                </div>
              </section>

            </div>
          </div>
        </div>
      </main>

      <LandingFooter />
    </div>
  );
}
